var CustomerEmailModule = (function (app, TwoStepsView, CustomerEmailView) {

    return {
        init: function (order) {
            $(function () {
                app.settings.ready(function () {
                    var s = app.settings.get();

                    //return settings && settings.UseGuestCheckoutTwoSteps && TwoStepsView || CustomerEmailView;

                    if (s.UseGuestCheckoutTwoSteps) {

                        new TwoStepsView({ el: $('@customerEmail1'), signinForm: true, onlyEmail: false, onlyTC: false, signInButton: true, switchers: false, agreementText: false });

                        new TwoStepsView({ el: $('@customerEmail5'), signinForm: false, onlyEmail: true, onlyTC: false, signInButton: false, switchers: false, agreementText: false });
                        new TwoStepsView({ el: $('@customerEmail4'), signinForm: false, onlyEmail: true, onlyTC: false, signInButton: false, switchers: false, agreementText: false });
                        new TwoStepsView({ el: $('@customerEmail6'), signinForm: false, onlyEmail: true, onlyTC: false, signInButton: false, switchers: false, agreementText: false });

                        new TwoStepsView({ el: $('@customerEmail2'), signinForm: false, onlyEmail: false, onlyTC: true, signInButton: false, switchers: false, agreementText: true });

                        order.on('sync', function (m) {
                            setTimeout(function () {
                                var $el = $('#CustomerEmail:visible');
                                var el = $el && $el[0] || null;
                                if (el) {
                                    el.focus({ preventScroll: false });
                                }
                            }, 2000);
                        });

                    } else {
                        $(function () {
                            new CustomerEmailView({ el: $('@customerEmail1'), onlyEmail: true });
                            new CustomerEmailView({ el: $('@customerEmail4'), onlyEmail: true });
                            new CustomerEmailView({ el: $('@customerEmail5'), onlyEmail: true });
                            new CustomerEmailView({ el: $('@customerEmail6'), onlyEmail: true });

                            new CustomerEmailView({ el: $('@customerEmail2'), onlyButtons: true });
                        });
                    }
                });
            });
        }
    }

})(app, TwoStepsView, CustomerEmailView);